import { useAtomValue } from 'jotai';
import React from 'react';

import { yakumaruRequestErrorNotificationsState } from '~/state/layouts/SharedAppShell/atoms';

import { useSubscriptionYakumaruRequestErrorNotifications } from './use-subscription-yakumaru-request-error-notifications';
import { YakumaruRequestErrorNotification } from './YakumaruRequestErrorNotification';

export const YakumaruRequestErrorNotifications = () => {
  const { notifications } = useAtomValue(yakumaruRequestErrorNotificationsState);
  const { handleClose } = useSubscriptionYakumaruRequestErrorNotifications();

  return (
    <>
      {notifications.map((notification) => (
        <YakumaruRequestErrorNotification
          key={notification.id}
          notification={notification}
          onClose={handleClose}
        />
      ))}
    </>
  );
};
